import { SortDirection } from "@angular/material/sort";

export const DEVICE_SELECT_FIELDS: string[] = [
    'id',
    'azureADDeviceId',
    'deviceName',
    'userDisplayName',
    'userPrincipalName',
    'emailAddress',
    'operatingSystem',
    'osVersion',
    'complianceState',
    'managementState',
    'lastSyncDateTime',
    'enrolledDateTime',
    'manufacturer',
    'model',
    'serialNumber',
];

export const DEFAULT_ORDER_BY = 'deviceName';
export const DEFAULT_ORDER_DIRECTION: SortDirection = 'asc';
export const DEFAULT_TOP = 20;